<template xmlns:font-size="http://www.w3.org/1999/xhtml">
  <a-drawer
    :title="title"
    :width="577"
    @close="onClose"
    :visible="visible"
    :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
  >
    <a-card title="结算信息" :bordered="false">

      <div class="content-block" v-if="model.bankType">
        <div>结算类型：</div>
        <div>{{model.bankType | filterBankType }}</div>
      </div>
      <div class="content-block" v-if="model.bankAccountName">
        <div>结算开户名：</div>
        <div>{{model.bankAccountName}}</div>
      </div>
      <div class="content-block" v-if="model.bankNo">
        <div>结算银行账号：</div>
        <div>{{model.bankNo}}</div>
      </div>
      <div class="content-block" v-if="model.bankName">
        <div>结算开户银行支行名称：</div>
        <div>{{model.bankName}}</div>
      </div>
      <div class="content-block" v-if="model.bankAddress">
        <div>结算开户银行所在地：</div>
        <div>{{model.bankAddress}}</div>
      </div>
    </a-card >
  </a-drawer>
</template>

<script>
import { getShopApply, addShopApply, updateShopApply } from '@/api/shop/shopApply'
export default {
  name: "SettlementDetails",
  props: {
  },
  components: {
  },
  data() {
    return {
      title: "详情",
      visible: false,
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      uploadLoading: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      url: {
        imgerver: window._CONFIG['fileURL'],
      },
    }
  },
  created() {
  },
  filters:{
    filterBankType(val) {
      if(val == 1) {
        return '借记卡'
      }else if(val == 2) {
        return '企业户'
      }else if(val == 3) {
        return '二类户'
      }else if(val == 4) {
        return '三类户'
      }
    }

  },
  methods: {
    show(record) {
      this.model = record.settleMessage;
      this.visible = true;
    },
    onClose() {
      this.visible = false
    },

  }
}
</script>

<style lang="less" scoped>
.content-block {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  line-height: 37px;
  flex-wrap: wrap;
}
</style>
